// @flow
export const acronym = (string: ?string): string | null => {
  if (string == null) {
    return '';
  }

  const matches = string.match(/\b(\w)/g);
  return matches ? matches.join('') : null;
};
